import MeaButton from "../../../../components/MeaButton";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import { ToFormatedDateWithWeekday } from "../../../../utils/dates";
import { useRef } from "react";
import UpdateRegistrationWaitingDetailsModal from "../modals/UpdateRegistrationWaitingDetailsModal";
import { Card } from "primereact/card";
import { PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import RegistrationStepActions from "./RegistrationStepActions";

const RegistrationStepWaitingListComponent = ({ currentStudent, setCurrentStudent, callback, schoolId, trainingId }) => {

    const { hasPermission } = useAuthContext();

    const hasUpdateRegistrationsStatusPermission = hasPermission(PERMISSION_TRAINING_TASKS.UPDATE_REGISTRATIONS_STATUS)

    const updateRegistrationWaitingDetailsModalRef = useRef(null);

    const statusActionsRef = useRef(null);

    const footerTemplate = (options) => {
        const className = `${options.className} flex flex-wrap align-items-center justify-content-between`;
        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                </div>
                <RegistrationStepActions
                    ref={statusActionsRef}
                    currentStudent={currentStudent}
                    schoolId={schoolId}
                    trainingId={trainingId}
                    callback={callback}
                    primary={{
                        label: "Remettre en candidature",
                        icon: "pi pi-inbox",
                        severity: "warning",
                        outlined: true,
                        disabled: !hasUpdateRegistrationsStatusPermission,
                        onClick: () => statusActionsRef.current?.changeStatus("NEW"),
                    }}
                    items={[
                        {
                            label: "Désinscrire",
                            icon: "pi pi-sign-out",
                            visible: hasUpdateRegistrationsStatusPermission,
                            command: () => statusActionsRef.current?.changeStatus("UNREGISTRED"),
                        },
                    ]}
                />
            </div>
        );
    };

    return (
        <>
            {(currentStudent?.status === "WAITING_LIST") &&
                <Card footer={footerTemplate} >
                    <ul className="list-none p-0 m-0">
                        <li className="flex align-items-center py-2 px-2 flex-wrap  ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Depuis</div>
                            <div className="text-900 w-full pl-3 md:w-5">
                                <div className="w-full">{currentStudent?.on_waiting_list_since_date ? ToFormatedDateWithWeekday(new Date(currentStudent?.on_waiting_list_since_date)) : "-"}</div>
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Détails</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                <div className="flex justify-content-between flex-wrap align-items-center">
                                    <div className="w-10">{currentStudent?.on_waiting_list_details || "-"}</div>
                                    <div className="w-2"><MeaButton permission={PERMISSION_TRAINING_REGISTRATION.UPDATE} icon="pi pi-pencil" className="mr-2" size="small" text onClick={() => {
                                        if (updateRegistrationWaitingDetailsModalRef.current) {
                                            updateRegistrationWaitingDetailsModalRef.current.show(() => {
                                                callback?.();
                                            });
                                        }
                                    }} /></div>
                                </div>
                            </div>

                        </li>
                    </ul>

                </Card>}
            <UpdateRegistrationWaitingDetailsModal ref={updateRegistrationWaitingDetailsModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
        </>
    );
}

export default RegistrationStepWaitingListComponent;